// extracted by mini-css-extract-plugin
module.exports = {"container":"zg","copy":"Ag","field":"Bg","error":"Cg","disabled":"Dg","termsContainer":"Eg","termsHeading":"Fg","termsCopy":"Gg","submit":"Hg","srOnly":"Ig"};